/**
 * Sound toggle button (BUILD_SPEC.md §16.1).
 *
 * UI is fully wired but no audio actually plays yet — the spec puts
 * audio playback in Milestone 7. Today, clicking the button just
 * flips the persisted preference.
 */

import { Volume2, VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSoundStore } from "@/stores/soundStore";

interface Props {
  size?: "sm" | "md";
}

export function SoundToggle({ size = "md" }: Props) {
  const { t } = useTranslation();
  const enabled = useSoundStore((s) => s.enabled);
  const toggle = useSoundStore((s) => s.toggle);
  const Icon = enabled ? Volume2 : VolumeX;
  const label = enabled ? t("common.soundOn") : t("common.soundOff");
  const dim = size === "sm" ? "h-4 w-4" : "h-5 w-5";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      aria-pressed={enabled}
      title={label}
      className="rounded-md p-2 text-fg dark:text-fg-dark hover:bg-hairline/40 dark:hover:bg-hairline-dark/40 transition-colors"
    >
      <Icon className={dim} aria-hidden />
    </button>
  );
}
